import { ErrorBoundary } from "components";
import { MIN_HEIGHT } from "../../Charts.const";
import { Horizontal } from "./Horizontal";
import { Vertical } from "./Vertical";
import type { BarChartProps } from "../BarChart";
import { defaultKeys } from "../BarChart";

/** The pre-restyle visx chart. */
const LegacyBarChart = ({
  orientation,
  isLoading,
  data,
  margins,
  stretch = false,
  showXAxis = true,
  noDataMessage,
  valueAxisLabel,
  labelAxisLabel,
  id,
  title,
  colorRange,
  exportMode = undefined,
  minHeight = MIN_HEIGHT,
  valueNumTicks = 6,
  keys = defaultKeys,
  maxXAxisHeight,
  tooltipRenderer,
}: BarChartProps) => {
  const Component = orientation === "horizontal" ? Horizontal : Vertical;

  return (
    <ErrorBoundary>
      <Component
        minHeight={minHeight}
        colorRange={colorRange}
        exportMode={exportMode}
        id={id}
        title={title}
        isLoading={isLoading}
        data={data}
        margins={margins}
        stretch={stretch}
        showXAxis={showXAxis}
        noDataMessage={noDataMessage}
        valueAxisLabel={valueAxisLabel}
        labelAxisLabel={labelAxisLabel}
        valueNumTicks={valueNumTicks}
        keys={keys}
        maxXAxisHeight={maxXAxisHeight}
        tooltipRenderer={tooltipRenderer}
      />
    </ErrorBoundary>
  );
};

export { LegacyBarChart };
